import React from 'react';
import { Animated } from 'react-native';


export const DragAndDropContext = React.createContext({
  draggedItem: null,
  setDraggedItem: () => {},
  translateY: new Animated.Value(0),
});

export const STATUS = {
  INACTIVE: 'INACTIVE',
  TOUCHED: 'TOUCHED',
  DRAGGED: 'DRAGGED',
  HORIZONTAL: 'HORIZONTAL',
};

export const { Consumer } = DragAndDropContext;

export const INITIAL_STATE = {
  item: null,
  index: -1,
  itemOffsetY: 0,
  touchStatus: STATUS.INACTIVE,
  translateY: new Animated.Value(0),
};

export default DragAndDropContext;
